/**
 * Nuclia Session Service
 * Handles fetching and caching the user's Nuclia session ID
 */

let sessionIdCache: string | null = null;

export async function fetchNucliaSessionId(): Promise<string | null> {
    try {
        const response = await fetch('/api/nuclia/session', {
            credentials: 'include'
        });

        if (!response.ok) {
            console.error('Failed to fetch Nuclia session ID:', response.status);
            return null;
        }

        const sessionId = await response.text();
        sessionIdCache = sessionId;
        return sessionId;
    } catch (error) {
        console.error('Error fetching Nuclia session ID:', error);
        return null;
    }
}

export function getCachedSessionId(): string | null {
    return sessionIdCache;
}

export function clearSessionId(): void {
    sessionIdCache = null;
}
